import React from "react";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { fromatShortDateAndTime } from "../../utilities";
import moment from "moment";
import EmailPreview from "./EmailPreview";
import EmailFull from "./EmailFull";
import { DeleteDialog } from "../../components";
import CollapsiblePreview from "../../components/CollapsiblePreview/CollapsiblePreviews";
import VisibleToExternalIcon from "../../components/VisibleToExternal/VisibleToExternalIcon";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { useIsInternal } from "common/SessionContext";

interface Props {
  canDelete: boolean
  email: server.dto.EmailMessage
  onDelete: (email: server.dto.EmailMessage) => Promise<void>
}

const EmailRowCard = ({ email, onDelete, canDelete }: Props) => {
  const isInternalUser = useIsInternal();
  const [isDeleting, setIsDeleting] = React.useState(false);

  let collapsible = false;

  const maxContentLength = 100;
  let shortBody = email.htmlBody;
  if (shortBody) {
    const brIndex = email.htmlBody.indexOf("<br");
    if (brIndex > -1) {
      // First line upto the first <br>
      shortBody = shortBody.substring(0, brIndex);
    } else {
      shortBody = shortBody.substring(maxContentLength);
    }
    collapsible = true;
  }

  return <div>
    <div>
      <UserAvatar user={email.sendBy} />
    </div>

    <div className="no-wrap" style={{ width: 150 }}>
      <div>{email.sendBy.fullName}</div>
      <div className="text-sublabel">{fromatShortDateAndTime(moment.utc(email.sendUtc).tz(site.userPreference.regional.ianaTimeZoneId))}</div>
      {isInternalUser && <VisibleToExternalIcon visibleToExternal={email.visibleToExternal} />}
    </div>

    <CollapsiblePreview
      onlyShowFullView={!collapsible}
      preview={<EmailPreview email={email} shortBody={shortBody} />}
      fullView={<EmailFull email={email} />}
    />

    {canDelete && <PhosphorTrashButton
      layout="in-square"
      onClick={() => { setIsDeleting(true); }}
    />}

    <DeleteDialog
      isOpen={isDeleting}
      onDelete={async () => onDelete(email)}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setIsDeleting(false); }}
    />
  </div>;
};

export default EmailRowCard;